import * as React from 'react';
import { Component } from 'react';
import { getFormComponent } from './utils';

class DefaultColumnFormSection extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const components = (<div className="form-fields">
            {
                this.props.section.zones[0].formComponents.map((formComponent, key) => {
                    return getFormComponent(formComponent, this.props);
                })
            }
        </div>);
        return (
            <div style={this.props.visible && !this.props.posted ? {} : { display: "none" }} className="form-section">
                <div className="row">
                    <div className="col-md-12">{components}</div>
                </div>
            </div>
        )
    }
}

export default DefaultColumnFormSection;